export const meta = { id: 'O14', slug: 'organizar-modulos', title: 'Como criar e organizar Módulos', description: 'Agrupe Aulas em Módulos e defina uma sequência de aprendizagem coerente.', profile: 'owner', category: 'treinamentos', type: 'task', status: 'published', order: 440, keywords: ['módulos','organizar módulos','treinamento','aulas'], previous: 'O13', next: 'O15', related: ['O13','O15','O16'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como criar e organizar Módulos

Módulos agrupam aulas que pertencem ao mesmo momento da aprendizagem.

<HelpImage pendingId="O13.1" alt="Estrutura de módulos de um Treinamento" />

<Steps>
  <Step title="Crie o Módulo">Use um título que deixe claro o assunto ou etapa.</Step>
  <Step title="Inclua as Aulas">Adicione apenas conteúdos coerentes com o objetivo do módulo.</Step>
  <Step title="Defina a ordem">Organize os módulos e as aulas conforme a progressão desejada.</Step>
  <Step title="Revise o percurso">Observe a experiência pela perspectiva do Aluno.</Step>
</Steps>
